<div class="app-menu navbar-menu">
  <div id="scrollbar">
    <div class="container-fluid">
      <div id="two-column-menu"></div>
      <ul class="navbar-nav" id="navbar-nav">
        @for (item of menuItems; track item) {
          @if (item.isTitle) {
            <li class="menu-title">
              <span data-key="t-menu">{{ item.label | translate }}</span>
            </li>
          }
          @if (!item.isTitle && !item.isLayout) {
            <li class="nav-item">
              @if (hasItems(item)) {
                <a href="javascript:void(0);" class="is-parent nav-link menu-link" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}" data-bs-toggle="collapse" aria-expanded="false">
                  <i class="{{ item.icon }} icon nav-icon" class=""></i>
                  <span class=""> {{ item.label | translate }}</span>
                  @if (item.badge) {
                    <span class="badge badge-pill {{item.badge.variant}}">{{item.badge.text | translate }}</span>
                  }
                </a>
              }
              @if (!hasItems(item)) {
                <a [routerLink]="item.link" [routerLinkActive]="'active'" [routerLinkActiveOptions]="item.label === 'MENUITEMS.PROJECTS' ? {exact: false} : {exact: true}" class="side-nav-link-ref nav-link menu-link">
                  @if (item.icon) {
                    <i class="bx {{ item.icon }} icon nav-icon" class=""></i>
                  }
                  <span class=""> {{ item.label | translate }}</span>
                  @if (item.badge) {
                    <span class="badge {{item.badge.variant}} float-end">{{item.badge.text | translate }}</span>
                  }
                </a>
              }
              @if (hasItems(item)) {
                <div class="collapse menu-dropdown" id="sidebarDashboards">
                  @if (hasItems(item)) {
                    <ul class="nav nav-sm flex-column" aria-expanded="false">
                      @for (subitem of item.subItems; track subitem) {
                        <li class="nav-item">
                          @if (!hasItems(subitem)) {
                            <a class="nav-link pointer" role="none" [attr.data-parent]="subitem.parentId" (click)="onClick(subitem.modal)">
                              @if (subitem.icon) {
                                <i class="bx {{ subitem.icon }} icon nav-icon" class=""></i>
                                }{{ subitem.label | translate }}
                              </a>
                            }
                          </li>
                        }
                      </ul>
                    }
                  </div>
                }
              </li>
            }
          }
        </ul>
      </div>
    </div>
  </div>

  <app-create-user #createUser></app-create-user>
  <app-assign-project-member #assignProjectMember></app-assign-project-member>
  <app-create-project #createProject></app-create-project>
  <app-create-research-project #createResearchProject></app-create-research-project>